$('#gform_conditional_logic-js').attr('data-cookieconsent', 'ignore');
$('#gform_conditional_logic-js-extra').attr('data-cookieconsent', 'ignore');
$('#gform_json-js').attr('data-cookieconsent', 'ignore');
$('#gform_gravityforms-js-extra').attr('data-cookieconsent', 'ignore');
$('#gform_gravityforms-js').attr('data-cookieconsent', 'ignore');
$('#gform_gravityforms-js').attr('data-cookieconsent', 'ignore');
$("script[id^='wpackio_localMediaapp']").attr('data-cookieconsent', 'ignore');
$("script[id^='weglot-data']").attr('data-cookieconsent', 'ignore');
$("script[id^='wp-weglot-js-js']").attr('data-cookieconsent', 'ignore');
